import { Goal } from "@ctypes";
import { useUser } from "@hooks/user";

export const useGoals = () => {
  const { beneficiaries, ...rest } = useUser();

  const goals: Array<Goal> = [];

  beneficiaries?.forEach((beneficiary) => {
    beneficiary?.goals?.forEach((goal) => {
      if (goal) {
        goals.push(goal);
      }
    });
  });

  return { goals, ...rest };
};
